<mat-progress-bar *ngIf="submiting" color="primary" mode="indeterminate"></mat-progress-bar>
<mat-card class="mat-elevation-z6" [ngClass]="{ loading: submiting }">

    <div mat-card-image>

        <img src="assets/images/icon.png" alt="" />

    </div>

    <mat-card-header>
        <mat-card-title>Recupere sua senha</mat-card-title>
    </mat-card-header>

    <mat-card-content>

        <form [formGroup]="form">

            <div class="row">
                <mat-form-field  appearance="outline">
                    <mat-label>Sua nova senha</mat-label>
                    <input type="password" matInput placeholder="Informe sua nova senha" formControlName="password" />
                </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field  appearance="outline">
                    <mat-label>Repita sua nova senha</mat-label>
                    <input type="password" matInput placeholder="Repita sua nova senha" formControlName="password2" />
                </mat-form-field>
            </div>

        </form>

    </mat-card-content>

    <mat-card-actions>
        <button primary="color" class="custom-primary" mat-raised-button
            (click)="submit()" [disabled]="submiting">Salvar nova senha</button>
    </mat-card-actions>

</mat-card>